import Headerinner from "@components/Common/HeaderInner/Headerinner";
import Sidebar from "@components/Common/Sidebar/Sidebar";
import React, { useState } from "react";
import "./AuthPagesLayout.css";

interface ProtectedLayoutProps {
  children?: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);



  return (
    <div className="left-wrap">
      <div>
        <Sidebar isOpen={isMenuOpen} isMenuClose={() => setIsMenuOpen(false)} />
      </div>
      <div className="main-content d-flex flex-column">
        <div>
          <Headerinner MenuOpen={() => setIsMenuOpen(true)} />
        </div>
        <div className="right-wrap">
          {/*<a
                        href="#as"
                        className="logo"
                        title="Fonemed A Healthier Tomorrow"
                    ></a>*/}
          {children}
        </div>
      </div>
    </div>
  );
};
export default ProtectedLayout;
